"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var crumb_nav_1 = __importDefault(require("../../account-v3/components/crumb_nav"));
var app_1 = require("../app");
exports.default = (function (_a) {
    var basePath = _a.basePath;
    var context = (0, react_1.useContext)(app_1.NewReturnContext);
    var history = (0, react_router_dom_1.useHistory)();
    if (!context)
        return null;
    var returns = context.returns, returnComplete = context.returnComplete;
    if (!returns) {
        console.debug("No returns ");
        history.push("".concat(basePath, "/selectItems"));
    }
    var returnType = returns === null || returns === void 0 ? void 0 : returns.returnType;
    var text = (function () {
        switch (returnType) {
            case 'returnlessRefund':
                return window.returnsApp.copy.confirmationStepReturnlessRefundCopy;
            case 'returnlessRefundWithOffer':
                return window.returnsApp.copy.confirmationStepReturnlessRefundWithOfferCopy;
            default:
                return window.returnsApp.copy.confirmationStepRegularReturnCopy;
        }
    })();
    return (react_1.default.createElement("div", { className: 'padding-bottom-3 return-container' },
        react_1.default.createElement(crumb_nav_1.default, { current: 'Returns', backLink: '/returns/' }),
        react_1.default.createElement("div", { className: 'padding-top-10 padding-bottom-5 account-header' }, "Confirmation"),
        react_1.default.createElement("div", { className: 'padding-left-4 padding-right-4' },
            react_1.default.createElement("p", null,
                "Your Confirmation Code is ", returns === null || returns === void 0 ? void 0 :
                returns.rmaNumber,
                " ",
                returnType),
            react_1.default.createElement("div", { className: 'font-size-small font-lighter links-wisteria' },
                react_1.default.createElement("div", { className: 'margin-bottom-4 font-lighter font-size-small links-wisteria', dangerouslySetInnerHTML: { __html: text } }),
                react_1.default.createElement("br", null),
                "You can track the status of your return",
                ' ',
                react_1.default.createElement(react_router_dom_1.Link, { to: '/returns', replace: true, onClick: function () { return returnComplete(); } }, "here"),
                react_1.default.createElement(react_router_dom_1.Link, { className: 'button btn-form saveButton margin-top-4', type: 'button', to: '/returns/', replace: true, onClick: function () { return returnComplete(); } }, "Done")))));
});
